import PropTypes from 'prop-types';

import { SearchIcon } from '../../icons/SearchIcon';

import styles from './SearchInput.module.scss';

export function SearchInput({ value, setValue, placeholder = 'Search...' }) {
  return (
    <div className={styles.searchWrapper}>
      <SearchIcon color="#d4d4d4" />
      <input
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={styles.search}
        placeholder={placeholder}
      />
    </div>
  );
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
